import { render } from "./AllOrganizations.vue?vue&type=template&id=2e6be734"
import script from "./AllOrganizations.vue?vue&type=script&lang=js"
export * from "./AllOrganizations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__